import * as angular from 'angular';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name Auth
     * @memberof app
     *
     * @description
     * Ain't Nobody Got Time for That
     *
     * @author flzemke.btc
     */
    angular.module('app').factory('Auth', AuthResource);

    function AuthResource($resource) {
        return $resource(
            config.monolithApi + '/auth',
            {},
            {
                get: {
                    method: 'GET',
                    url: config.monolithApi + '/auth/'
                }
            }
        );
    }
})();
